import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { TIMEZONES } from '../../constants';

const TimeZoneDropdown = ({ timeZoneName, formik, defaultValue }) => {
  const selectOptions = TIMEZONES;
  // Set default value in Formik on first mount
  useEffect(() => {
    if (formik && defaultValue) {
      const exists = selectOptions.find((opt) => opt.value === defaultValue);
      if (exists && !formik.values[timeZoneName]) {
        formik.setFieldValue(timeZoneName, defaultValue);
      }
    }
  }, [defaultValue, formik, timeZoneName, selectOptions]);

  const selectedValue = selectOptions.find(
    (opt) => opt.value === formik?.values?.[timeZoneName]
  );

  const handleChange = (selected) => {
    if (formik) {
      formik.setFieldValue(timeZoneName, selected?.value || '');
    }
  };

  return (
    <Select
      name={timeZoneName}
      options={selectOptions}
      value={selectedValue || null}
      onChange={handleChange}
      onBlur={() => formik?.setFieldTouched(timeZoneName, true)}
      classNamePrefix="react-select"
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: '#0649b5',
          neutral10: '#edf2f9',
          neutral20: '#d2ddec',
          neutral30: '#d2ddec',
          neutral50: '#b1c2da',
          neutral80: '#12263f',
          dangerLight: '#DEEBFF',
          danger: '#12263f',
        },
      })}
    />
  );
};

TimeZoneDropdown.propTypes = {
  timeZoneName: PropTypes.string.isRequired,
  formik: PropTypes.object, // from useFormikContext or Formik props
  defaultValue: PropTypes.string,
};

export default TimeZoneDropdown;
